import { cloneDeep } from 'lodash';

const centsToEuro = (cents) => (typeof cents === 'number' ? cents / 100 : cents);
const formatPriceLabel = (euro) => `${euro.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')} €`;

const updatePlayerCamps = (player, cart, camp) => {
  // `player` is expected to already be a cloned object by the caller
  const playerToUpdate = player;

  playerToUpdate.stage.offers.forEach((offer) => {
    const playerStageWeeks = playerToUpdate.stage.weeks;
    cart.articles.forEach((article) => {
      const productUid = article.productUid;
      const articleWeek = article.week;
      const isPackageInCamp = camp.product.packagesIds.indexOf(playerToUpdate.stage.packageId) !== -1;
      if (isPackageInCamp && camp.product.id === productUid && playerStageWeeks.includes(articleWeek)) {
        const newPriceEuro = centsToEuro(article.new_price);
        // Toujours assigner l'ancien prix depuis le serveur (converti en euros).
        offer.oldPrice = centsToEuro(article.old_price);
        // stocker le prix de l'offre en euros (harmonisé avec AppContext)
        offer.price = newPriceEuro;
        offer.label = formatPriceLabel(newPriceEuro);
      }
    });
  });
  return playerToUpdate;
};

const applyArticleToOption = (article, option) => {
  const productUid = article.productUid;
  const articleWeek = article.week;
  if (option.productId !== productUid) return;
  const newPriceEuro = centsToEuro(article.new_price);
  option.quantities.forEach((quantity) => {
    if (quantity.weekId === articleWeek) {
      quantity.oldPrice = centsToEuro(article.old_price);
      quantity.price = newPriceEuro;
      quantity.label = formatPriceLabel(newPriceEuro);
    }
  });
};

const updatePlayerOptions = (player, cart) => {
  const playerToUpdate = player;
  if (playerToUpdate.options?.length) {
    cart.articles.forEach((article) => {
      playerToUpdate.options.forEach((option) => applyArticleToOption(article, option));
    });
  }
  return playerToUpdate;
};

const updatePlayerExtras = (player, cart) => {
  const playerToUpdate = player;
  if (playerToUpdate.otherOptions?.length) {
    cart.articles.forEach((article) => {
      playerToUpdate.otherOptions.forEach((option) => applyArticleToOption(article, option));
    });
  }
  return playerToUpdate;
};

const applyArticleToHosting = (article, hostingOption, player) => {
  const productUid = article.productUid;
  if (hostingOption.productId !== productUid) return;
  const participants = hostingOption.participants?.[player.typeLabel];
  if (!participants || participants.length === 0) return;
  // match the player
  if (participants[0].playerId !== player.id) return;

  const newHostingPriceEuro = centsToEuro(article.new_price);
  hostingOption.oldPrice = centsToEuro(article.old_price);
  hostingOption.price = newHostingPriceEuro;
};

const updatePlayerHosting = (player, cart, hosting) => {
  const playerToUpdate = player;
  if (hosting?.length && cart?.articles?.length) {
    cart.articles.forEach((article) => {
      hosting.forEach((hostingOption) => applyArticleToHosting(article, hostingOption, playerToUpdate));
    });
  }
  return playerToUpdate;
};

const updatePlayersInCart = (player, cart, camp, hosting, preventClone) => {
  const playerToUpdate = preventClone ? player : cloneDeep(player);
  const hostingToUpdate = preventClone ? hosting : cloneDeep(hosting);

  let updatedPlayer = updatePlayerCamps(playerToUpdate, cart, camp);
  updatedPlayer = updatePlayerOptions(updatedPlayer, cart);
  updatedPlayer = updatePlayerExtras(updatedPlayer, cart);
  updatedPlayer = updatePlayerHosting(updatedPlayer, cart, hostingToUpdate);

  return { player: updatedPlayer, hosting: hostingToUpdate };
};

export default updatePlayersInCart;
